import requestManager from "../components/platformApi/requestManager";

import appHelper from "@util/appHelper";

export default {

    list : {
        url : 'portal/datum/list'
    },
    vipDatumList : {
        url : 'portal/user/vip/getVipDatum'
    },

    /**
     * @param   Object params
     */
    getDownloadUrl : function(id) {
        return {
            url: '',
            params: {
                id : id
            }
        };
    },

    /**
     * @param   {String}    datumId
     * @param   {String}    email
     * @param   {Function}  callback
     */
    sendEmail : function (datumId, email, callback) {
        requestManager.request({
            url : 'portal/datum/sendEmail',
            method : 'post',
            data : {
                datumId : datumId,
                email : email,
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },

    /**
     * @param   Function    callback    first param is response data
     */
    getTagList(callback) {
        requestManager.request({
            url : 'portal/datum/getTagList'
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },

    payFreeDatum(id, callback) {
        requestManager.request({
            url : 'portal/datum/pay_free_datum',
            data: {
                id: id
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    },

    clickDown(id, callback) {
        requestManager.request({
            url : '/portal/datum/v2/clickDown',
            data: {
                id: id
            }
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    },

    getDownCount(id, callback) {
        requestManager.request({
            url : '/portal/datum/getDownCount',
            data: {
                id: id
            }
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    },

    checkIsPay(id, callback) {
        requestManager.request({
            url : 'portal/datum/isPay',
            data: {
                datumId : id
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            callback(result);
        });
    }

};
